import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"rounded-lg"},[_vm._t("header"),_c(VCardText,{class:_vm.contentClass},[_c('apexchart',{staticClass:"w-100",attrs:{"id":"radar-chart","type":"radar","height":_vm.height,"width":_vm.width,"options":_vm.chartOptions,"series":_vm.series}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }